<template>
  <div class="d-flex" id="page-dashboard">
    <div class="layout-content container-fluid">    
      <div class="row mt-3 mt-md-5">
        <div class="col-12 mb-3 mb-md-5">
          <div class="cont-title d-flex align-items-center mb-4">
            <span class="icon icon-wait-clock mr-3"></span>
            <h3 class="mb-0">Derechos de petición en el tiempo</h3>
          </div>
          <!-- .cont-title -->
          <div class="shadow-1 cont-chart p-1 p-md-3">
            <div class="w-100 d-flex justify-content-end">
              Año:
              <select 
                v-model="yearSel"
                class="chart-select"
                @change="findDashboard">
                  <option :value="this.year">{{this.year}}</option>
                  <option :value="this.year-1">{{this.year-1}}</option>
                  <option :value="this.year-2">{{this.year-2}}</option>
              </select>
            </div>
            <time-tickets-chart
              :chart-data="ticketsLineChartdatacollection"
              :options="ticketLineChartOptions"
            />
          </div>

          <div class="cont-title d-flex align-items-center mt-5">
            <span class="icon icon-wait-clock mr-3"></span>
            <h3 class="mb-0">Derechos de petición por categorías</h3>
          </div>
          <!-- .cont-title -->
          <div class="shadow-1 cont-chart p-1 p-md-3">            
            <bar-chart
              :chart-data="this.chartData"
              :options="this.options"
            ></bar-chart>
          </div>
          <!-- .cont-chart -->
        </div>
      <!-- .row -->
      <div class="mb-menu"></div>
      </div>
    <!-- .layout-content -->
    </div>
  </div>
  <!-- #page-dashboard -->
</template>

<script>
import { mapActions, mapState } from "vuex";
import serverConfig from "./../../services/config";
import TimeTicketsChart from "@/components/charts/TimeTicketsChart.js";
import BarChart from "@/components/charts/BarChart.js";
//import AvailabilityPermissionsChart from "@/components/charts/AvailabilityPermissionsChart.js";

export default {
  name: "DashboardDerechos",
  components: {
    TimeTicketsChart,
    BarChart,
    //AvailabilityPermissionsChart,
  },
  data() {
    return {
      serverPath: serverConfig.permisosURL,
      error: {
        flag: false,
        class: "", //is-valid
        message: "",
      },
      success: {
        flag: false,
        class: "", //is-invalid
        message: "",
      },
      laborUnion: 1,
      year: new Date().getFullYear(),
      yearSel: "",
      yearSel2: "",
      halfLicenses: 0,
      ticketsLineChartdatacollection: {},
      ticketLineChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          align: "center",
          labels: {
            boxWidth: 15,
            fontSize: 15,
            padding: 10,
          },
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
          yAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
        },
      },
      available_licenses: 0,
      available_tickets: 0,
      available_viatics: 0,
      population: 127,
      availabilityPermisionsChartdatacollection: {},
      availabilityTicketsChartdatacollection: {},
      availabilityViaticsChartdatacollection: {},
      availabilityPermisionChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 80,
        legend: {
          display: false,
        },
      },
      availabilityTicketsChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 80,
        legend: {
          display: false,
        },
      },

      /*item: 'Permisos',
      opcionItem: [
        { value: 'Permisos', text: 'Permisos'},          
        { value: 'TiquetesNacionales', text: 'Tiquetes nacionales'},
        { value: 'TiquetesInternacionales', text: 'Tiquetes internacionales'},
        { value: 'Viaticos', text: 'Viáticos'},
      ],*/

      sitesSelect: '',
      opcionSites: [{
        value: "",
        text: "-- Todas --",
      }],
      societySelect: '',
      opcionSocieties: [{
        value: "",
        text: "-- Todas --",
      }],

      chartData: {},
        options: {
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true
              },
              gridLines: {
                display: true
              }
            }],
            xAxes: [{
              gridLines: {
                display: false
              }
            }]
          },
          legend: {
            display: true
          },
          responsive: true,
          maintainAspectRatio: false
        },

      titleOption: 'Dashboard de Permisos Sindicales'
    };
  },
  beforeMount() {

    this.actGetDashboardRP(this.year).then(() =>{
      this.fillTicketsLineChartData(this.year);
      this.findItemBar(this.year);
    });    
  },
  computed: {    
    ...mapState("modCore", ["user"]),
    ...mapState("modRightPetition",[
      "dashboard",
    ]),    
  },
  methods: {
    ...mapActions("modRightPetition", [
      "actGetDashboardRP",    
    ]),

    findDashboard(){
      this.actGetDashboardRP(this.yearSel).then(() =>{
        this.fillTicketsLineChartData(this.yearSel);
        this.findItemBar(this.yearSel);
      });
    },

    fillTicketsLineChartData(year) {
      //this.available_licenses = this.dashboard.data[year].available_licenses;
      //this.available_tickets = this.dashboard.data[year].available_tickets;
      //this.available_viatics = this.dashboard.data[year].available_viatics;
      //alert(JSON.stringify(this.dashboard.data));
      this.ticketsLineChartdatacollection = {
        labels: [
          "Enero",
          "Febrero",
          "Marzo",
          "Abril",
          "Mayo",
          "Junio",
          "Julio",
          "Agosto",
          "Septiembre",
          "Octubre",
          "Noviembre",
          "Diciembre",
        ],
        datasets: [
          {
            label: "Total Dererechos Petición",
            backgroundColor: "#4F656E",
            borderColor: "#4F656E",
            fill: true,
            data: [
              this.dashboard.data[year].monthly_report[0].January.Total_petition_rights,
              this.dashboard.data[year].monthly_report[1].February.Total_petition_rights,
              this.dashboard.data[year].monthly_report[2].March.Total_petition_rights,
              this.dashboard.data[year].monthly_report[3].April.Total_petition_rights,
              this.dashboard.data[year].monthly_report[4].May.Total_petition_rights,
              this.dashboard.data[year].monthly_report[5].June.Total_petition_rights,
              this.dashboard.data[year].monthly_report[6].July.Total_petition_rights,
              this.dashboard.data[year].monthly_report[7].August.Total_petition_rights,
              this.dashboard.data[year].monthly_report[8].September.Total_petition_rights,
              this.dashboard.data[year].monthly_report[9].October.Total_petition_rights,
              this.dashboard.data[year].monthly_report[10].November.Total_petition_rights,
              this.dashboard.data[year].monthly_report[11].December.Total_petition_rights,              
            ],
          },
          {
            label: "Cerrados",
            backgroundColor: "#8196AA",
            borderColor: "#8196AA",
            data: [
              this.dashboard.data[year].monthly_report[0].January.Petition_rights_answered,
              this.dashboard.data[year].monthly_report[1].February.Petition_rights_answered,
              this.dashboard.data[year].monthly_report[2].March.Petition_rights_answered,
              this.dashboard.data[year].monthly_report[3].April.Petition_rights_answered,
              this.dashboard.data[year].monthly_report[4].May.Petition_rights_answered,
              this.dashboard.data[year].monthly_report[5].June.Petition_rights_answered,
              this.dashboard.data[year].monthly_report[6].July.Petition_rights_answered,
              this.dashboard.data[year].monthly_report[7].August.Petition_rights_answered,
              this.dashboard.data[year].monthly_report[8].September.Petition_rights_answered,
              this.dashboard.data[year].monthly_report[9].October.Petition_rights_answered,
              this.dashboard.data[year].monthly_report[10].November.Petition_rights_answered,
              this.dashboard.data[year].monthly_report[11].December.Petition_rights_answered,
            ],
          },
          {
            label: "Abiertos",
            backgroundColor: "#8196AA",
            borderColor: "#8196AA",
            data: [
              this.dashboard.data[year].monthly_report[0].January.Petition_rights_not_answered,
              this.dashboard.data[year].monthly_report[1].February.Petition_rights_not_answered,
              this.dashboard.data[year].monthly_report[2].March.Petition_rights_not_answered,
              this.dashboard.data[year].monthly_report[3].April.Petition_rights_not_answered,
              this.dashboard.data[year].monthly_report[4].May.Petition_rights_not_answered,
              this.dashboard.data[year].monthly_report[5].June.Petition_rights_not_answered,
              this.dashboard.data[year].monthly_report[6].July.Petition_rights_not_answered,
              this.dashboard.data[year].monthly_report[7].August.Petition_rights_not_answered,
              this.dashboard.data[year].monthly_report[8].September.Petition_rights_not_answered,
              this.dashboard.data[year].monthly_report[9].October.Petition_rights_not_answered,
              this.dashboard.data[year].monthly_report[10].November.Petition_rights_not_answered,
              this.dashboard.data[year].monthly_report[11].December.Petition_rights_not_answered,
            ],
          },
        ],
      };
    },    
        
    findItemBar(year){
      let labels = [];
      let data = [];
      let fondo = [];
      let border = [];

      this.dashboard.data[year].categories_report.forEach((row) => {        
        let categoria = Object.keys(row);
        labels.push(categoria);
        
        for (let clave in row){
          data.push(row[clave].petition_rights);
          fondo.push('rgba(255, 99, 132, 0.2)');
          border.push('rgba(255,99,132,1)');
        }
      });

      this.chartData = {
      labels: labels,
          datasets: [{
            label: year,
            borderWidth: 1,
            backgroundColor: fondo,
            borderColor: border,
            pointBorderColor: '#2554FF',
            data: data
          }]
      }     
    },

    stringConvert(str){
      return str.toLowerCase()
            .trim()
            .split(' ')
            .map( v => v[0].toUpperCase() + v.substr(1) )
            .join(' ');  
    },

    getRandomInt() {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5;
    },

  },
};
</script>

<style lang="scss">
#page-dashboard {
  .cont-title {
    h3 {
      color: #1c3a4e;
      font-size: 12px;
      line-height: 18px;
      line-height: 22px;

      @media (min-width: 768px) {
        font-size: 16px;
        line-height: 20px;
      }
    }

    .icon {
      color: #1c3a4e;
      font-size: 18px;

      @media (min-width: 768px) {
        font-size: 22px;
      }
    }
  }

  .cont-chart {
    .chart-select {
      border: 0 none;
      color: #303030;
      font-weight: 500;
      outline: none;

      &:focus {
        outline: none;
      }
    }
  }

  .cont-doughnut-chart {
    .cont-txt {
      color: #303030;
      width: 126px;
      height: 120px;
      top: calc(50% - 60px);
      left: calc(50% - 63px);

      .title {
        font-size: 14px;
        margin-bottom: 0;
      }
      .number {
        font-size: 40px;
        line-height: 40px;
        font-weight: bold;
        margin-bottom: 0;
        padding: 10px 0;
      }

      .cont-desc {
        font-size: 12px;
        p {
          margin-bottom: 0;
        }
      }
    }
  }

  .cont-permisions {
    color: #303030;
    .number {
      font-size: 28px;
      font-weight: bold;

      @media (min-width: 768px) {
        font-size: 48px;
      }
    }
    .txt {
      font-size: 14px;
      line-height: 16px;

      @media (min-width: 768px) {
        font-size: 16px;
        line-height: 18px;
      }
    }
  }
}
</style>